import React from 'react';
import { Box, Button } from '@mui/material';
import DarkButtonWithIcon from 'components/common/button/DarkButtonWithIcon';

const TeamFollowUpReminderButtons = ({
    onSendTest,
    onCancel,
    onUpdate,
    disabled = false,
    testEmailLoading = false
}) => {
    // Common button styles for secondary/grey buttons
    const secondaryButtonStyles = {
        backgroundColor: '#e1e1e1',
        color: '#a6a6a6',
        fontWeight: 700,
        borderRadius: '20px',
        textTransform: 'none',
        display: 'flex',
        alignItems: 'center',
        fontSize: '0.7rem',
        border: '1px solid #e1e1e1',
        '&:hover': {
            backgroundColor: '#d5d5d5',
            border: '1px solid #d5d5d5',
            boxShadow: 'none',
        },
        padding: '8px 16px',
        minWidth: '100px',
        height: '34px',
        boxShadow: 'none',
        '&.Mui-disabled': {
            backgroundColor: '#f5f5f5',
            color: '#c4c4c4',
            border: '1px solid #f5f5f5',
        }
    };

    return (
        <Box
            sx={{
                backgroundColor: 'white',
                padding: 2,
                display: 'flex',
                justifyContent: 'space-between',
                boxShadow: '0 -2px 4px rgba(0,0,0,0.05)',
                borderTop: '1px solid #e1e1e1',
                flexShrink: 0
            }}
        >
            {/* Left side - Send Test Email button */}
            <Button
                variant="contained"
                onClick={onSendTest}
                disabled={disabled || testEmailLoading}
                sx={secondaryButtonStyles}
                disableElevation
            >
                {testEmailLoading ? 'Sending...' : 'Send Test Email'}
            </Button>

            {/* Right side - Cancel and Update buttons */}
            <Box sx={{ display: 'flex', gap: 2 }}>
                <Button
                    variant="contained"
                    onClick={onCancel}
                    disabled={disabled}
                    sx={secondaryButtonStyles}
                    disableElevation
                >
                    Cancel
                </Button>
                <DarkButtonWithIcon
                    text="Update"
                    onClick={onUpdate}
                    disabled={disabled}
                    sx={{
                        minWidth: '100px',
                        height: '34px',
                        fontSize: '0.7rem' // Match the other buttons' size
                    }}
                />
            </Box>
        </Box>
    );
};

export default TeamFollowUpReminderButtons;